module.exports = __webpack_public_path__ + "static/media/rareChest__top--closed.9dfe0bae.png";